







import { Component, Vue } from 'vue-property-decorator';
import CustomerPaymentBehaviourList from '@/components/Invoicing/Invoice/CustomerPaymentBehaviourList.vue';

@Component({
  components: {
    CustomerPaymentBehaviourList,
  },
})
export default class CustomerPaymentBehaviour extends Vue {}
